import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/core/assets/icons/icon-logout.svg'


const _withScopeId = n => (_pushScopeId("data-v-17f12476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-dropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logout",
  class: "icon"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Sign Out ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down = _resolveComponent("drop-down")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_drop_down, {
      direction: "left",
      "horizontal-offset": 10,
      "vertical-offset": 12
    }, {
      clickable: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      "main-actions": _withCtx(() => [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
        }, _hoisted_4)
      ]),
      _: 3
    })
  ]))
}